import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  justify-content: center;
  align-items: center;
  max-width: 1280px;
  margin: auto;
  margin-top: 0px;
`

const StyledTitle = styled.h2`
  font-size: 24px;
  margin: 0;
  padding: 1.5rem;
  margin-bottom: 24px;

  @media screen and (max-width: 768px) {
    padding: 0.75rem;
  }
`

const StyledIframe = styled.div`
  @media screen and (min-width: 769px) {
    padding: 0 4rem 4rem;
    width: 100%;
    max-width: 1280px;
  }
  margin: 0 auto 24px;
`

const Avis = () => (
  <Container>
    <StyledTitle>Ils ont économisé grâce à notre partenaire</StyledTitle>
    <StyledIframe>
      <div
        className="trustpilot-widget"
        data-locale="fr-FR"
        data-template-id="53aa8912dec7e10d38f59f36"
        data-businessunit-id="50ebeaee00006400052073d7"
        data-style-height="140px"
        data-style-width="100%"
        data-theme="light"
        data-stars="1,2,3,4,5"
        data-review-languages="fr"
        data-font-family="Montserrat"
        data-text-color="#170a33"
      >
        <a href="https://fr.trustpilot.com/review/www.desbrasenplus.com" target="_blank" rel="noopener noreferrer">
          Trustpilot
        </a>
      </div>
    </StyledIframe>
  </Container>
)

export default Avis
